// hooks/useWebSocket.js
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useRef } from "react";
import {
  connectWebSocket,
  disconnectWebSocket,
  sendWebSocketMessage,
} from "../store/chats/slice";

export const useWebSocket = (connect = false) => {
  const dispatch = useDispatch();
  const { isConnected } = useSelector((state) => state?.chats);

  useEffect(() => {
    if (!connect) return;
    dispatch(connectWebSocket());

    return () => {
      dispatch(disconnectWebSocket());
    };
  }, [connect, dispatch]);

  const sendMessage = useCallback((data) => {
    dispatch(sendWebSocketMessage(data));
  }, []);

  return { isConnected, sendMessage };
};
